import React, {useState} from "react";
import cermaqIcon from "../../assets/images/cermaq.png";
import logoIcon from "../../assets/images/logos.png";
import imageBg from "../../assets/images/bg-login.jpeg";
import "./access.scss";
import {Navigate, useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import * as yup from "yup";
import {sigIn} from "../../api/access";
import {localSession} from "../../helpers/local-storage";
import {LOCAL_SESSION} from "../../constants/local-entity";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import Loading from "../../components/loading/Loading";
import {Device} from "@capacitor/device";
import {Network} from "@capacitor/network";
import {getUserByEmail} from "../../mongo-db/users";
import {requestToken} from "../../mongo-db/auth";
import {LOCAL_TOKEN} from "../../constants/local-entity";

const Access = () => {
  const navigate = useNavigate();

  const session = localSession.getItem(LOCAL_SESSION);

  const [loading, setLoading] = useState(false);
  const [isPass, setIsPass] = useState(true);

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: yup.object({
      username: yup
        .string()
        .email("Email no válido")
        .required("Completa este campo"),
      password: yup.string().required("Completa este campo"),
    }),
    onSubmit: async values => {
      setLoading(true);
      const username = values.username.toLocaleLowerCase();
      const password = values.password;
      const {platform} = await Device.getInfo();
      const {connected} =
        platform === "web"
          ? {connected: navigator.onLine}
          : await Network.getStatus();
      if (!connected) {
        setLoading(false);
        return alert("No es posible iniciar sesión por falta de conexión");
      }
      sigIn(username, password)
        .then(async (loginRes) => {
          const sessionAux = loginRes?.data?.[0];
          if (!sessionAux) throw new Error();

          // Obtener JWT primero (ruta pública)
          try {
            const tokenData = await requestToken(username);
            localStorage.setItem(LOCAL_TOKEN, tokenData.token);
          } catch (tokenErr) {
            console.warn("No se pudo obtener JWT, continuando sin token:", tokenErr.message);
          }

          // Ahora sí consultar datos del usuario (requiere token)
          const user = await getUserByEmail(username);
          if (!user) throw new Error();

          if (user.active === false) {
            alert("Tu cuenta ha sido desactivada. Contacta al administrador.");
            return;
          }

          const session = {
            ...sessionAux,
            username,
            name: user.name || "",
            profile: user.profile,
            subUsuarios: user.subUsuarios || [],
            assignedCenters: user.assignedCenters || [],
          };

          localSession.setItem(LOCAL_SESSION, session);
          navigate("/cermaq/");
        })
        .catch(() => {
          alert("Usuario o contraseña incorrectos");
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  const usernameError =
    formik.touched.username && Boolean(formik.errors.username);
  const usernameHelperText = formik.touched.username && formik.errors.username;
  const passwordError =
    formik.touched.password && Boolean(formik.errors.password);
  const passwordHelperText = formik.touched.password && formik.errors.password;

  if (session?.Respuesta === 1) return <Navigate replace to="/cermaq" />;
  else
    return (
      <div
        className="w-100 login-container"
        style={{backgroundImage: `url(${imageBg})`}}
      >
        <div className="row">
          <div className="col-10 col-md-3 mx-auto mt-4">
            <div className="d-flex flex-column align-items-center">
              <img src={logoIcon} alt="CERMAQ" className="logo-icon mb-4" />
              <h1
                className="text-center"
                style={{
                  marginTop: '10px',
                  fontSize: '3rem',
                  color: '#41909a',
                  lineHeight: '1.1'
                }}
              >
                SSO SHIELD
              </h1>
            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-12 col-md-3 mx-auto mt-5 pt-5">
            <div className="card mb-5">
              <div className="card-body">
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="input-username" className="form-label">
                      Email
                    </label>

                    <input
                      type="text"
                      className={`form-control ${
                        usernameError ? "is-invalid" : ""
                      }`}
                      id="input-username"
                      aria-describedby="emailHelp"
                      name="username"
                      disabled={loading}
                      value={formik.values.username}
                      onChange={formik.handleChange}
                    />
                    {usernameError && (
                      <div className="invalid-feedback">
                        {usernameHelperText}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="input-password" className="form-label">
                      Contraseña
                    </label>
                    <div className="input-group">
                      <input
                        type={isPass ? "password" : "text"}
                        className={`form-control ${
                          passwordError ? "is-invalid" : ""
                        }`}
                        id="input-password"
                        name="password"
                        disabled={loading}
                        value={formik.values.password}
                        onChange={formik.handleChange}
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        onClick={() => setIsPass(prev => !prev)}
                      >
                        {isPass ? (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        ) : (
                          <FontAwesomeIcon icon={faEye} />
                        )}
                      </span>
                    </div>
                    {passwordError && (
                      <div className="invalid-feedback">
                        {passwordHelperText}
                      </div>
                    )}
                  </div>
                  <div className="d-flex">
                    <button
                      type="submit"
                      className="btn bg-primary ms-auto px-4 text-white"
                      disabled={loading}
                    >
                      Entrar
                      <Loading
                        loading={loading}
                        className="spinner-border-sm text-white ms-2"
                      />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default Access;
